<template>
    <div class="saveOrUpdateCrud descriptionsForm">
        <div>
            <el-page-header @back="close" content="打印入住协议登记"></el-page-header>
        </div>
        <div style="text-align: right;width: 80%;margin: auto;">
            <el-button type="primary" v-print="'#page'">打印</el-button>
        </div>
        <div class="page" style="margin: 10px auto;height: auto;" id="page">
            <div v-html="content"></div>
            <div style="margin-bottom: 10px;width: 100%;">
                <el-table border size="mini" :stripe="true" :data="upsertForm.sysHotelCheckHistories">
                    <el-table-column show-overflow-tooltip prop="name" label="姓名"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="phone" label="联系方式"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="createTime" label="提交时间"></el-table-column>
                </el-table>
            </div>
            <div v-if="upsertForm.remark" style="width: 100%;">
                备注：{{upsertForm.remark}}
            </div>
            <div style="margin-bottom: 10px;width: 100%;">
                <el-row>
                    <el-image style="height: 300px; margin: auto;" v-if="upsertForm.writeName" :src="config.resPre+upsertForm.writeName" :preview-src-list="[config.resPre+upsertForm.writeName]"></el-image>
                </el-row>
            </div>
            <div style="margin-bottom: 10px;width: 100%;">
                <el-row v-for="item in upsertForm.sysHotelCheckHistories">
                    <el-image v-if="item.idCardFrontImg" :src="config.resPre+item.idCardFrontImg" :preview-src-list="[config.resPre+item.idCardFrontImg]"></el-image>
                    <el-image v-if="item.healthCodeImg" :src="config.resPre+item.healthCodeImg" :preview-src-list="[config.resPre+item.healthCodeImg]"></el-image>
                </el-row>
            </div>


        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    let loading;
    export default {
        name: "printSysHotelChecks",
        props: ['title','id','agreementId'],
        data(){
            return {
                upsertForm:{
                    adminId: '',
                    adminName: '',
                    agreementId: '',
                    hotelId: '',
                    hotelName: '',
                    houseName: '',
                    names: '',
                    phones: '',
                    idCards: '',
                    userAgent: '',
                    browser: '',
                    os: '',
                    status: '',
                    startTime: '',
                    endTime: '',
                    days: '',
                    writeName: '',
                    claimTime: '',
                    claimAdminId: '',
                    claimAdminName: '',
                    remark:'',
                    updateTime: '',
                    createTime: '',
                    sysHotelCheckHistories:[],
                },
                content:'',
                config:config,
            }
        },
        created(){
            this.findCheckInfo();


        },
        mounted(){
            this.findInfo();
        },
        methods:{
            close(){
                this.$emit('closePrintCheck');
            },
            findCheckInfo() {
                axios({
                    url: `${home}/sysDdList/findCheckInfo/${this.agreementId}`,
                    method: "GET"
                }).then(res => {
                    this.content = res.data.content;

                }).catch(error => {

                });
            },
            findInfo(){
                axios({
                    url: `${home}/sysHotelCheck/update/findSysHotelCheckById/${this.id}`,
                    method: 'GET'
                }).then(res => {
                    Object.assign(this.upsertForm, res.data);
                }).catch(error => {

                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .page
    {
        width: 26cm;
        height: 1430px;
        padding: 1cm;
        margin: 1cm auto;
        border-radius: 5px;
        background: white;
    }
</style>
<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
